var _linearGradient, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f33f5e"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1026.362)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 1039.362,
    r: 13,
    fill: "url(#gradient)",
    className: "color3a6c87 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8 0C6.35 0 5 1.35 5 3c0 .936.443 1.763 1.12 2.314A6.424 6.424 0 0 0 3.114 7.36L3 7.498V9h1V7.902c.963-1.106 2.213-1.731 3.5-1.867V9h1V6.03c1.13.106 2.241.59 3.166 1.478.117.113.226.236.334.36V9h1V7.49l-.115-.138a6.76 6.76 0 0 0-.526-.567 6.339 6.339 0 0 0-2.472-1.474A2.983 2.983 0 0 0 11 3c0-1.65-1.35-3-3-3Zm0 1c1.11 0 2 .89 2 2 0 1.11-.89 2-2 2-1.11 0-2-.89-2-2 0-1.11.89-2 2-2Zm-5 9v.965A.5.5 0 0 0 3 11v2a.5.5 0 0 0 .006.09A1.506 1.506 0 0 0 2 14.5c0 .822.677 1.5 1.5 1.5S5 15.322 5 14.5c0-.65-.425-1.204-1.008-1.41A.5.5 0 0 0 4 13v-2h3.5v2a.5.5 0 0 0 .006.09A1.506 1.506 0 0 0 6.5 14.5c0 .822.677 1.5 1.5 1.5s1.5-.678 1.5-1.5c0-.65-.425-1.204-1.008-1.41A.5.5 0 0 0 8.5 13v-2H12v2a.5.5 0 0 0 .006.09A1.506 1.506 0 0 0 11 14.5c0 .823.677 1.5 1.5 1.5s1.5-.677 1.5-1.5c0-.65-.425-1.204-1.008-1.41A.5.5 0 0 0 13 13v-3H3zm.5 4c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 0 1-.5-.5c0-.282.218-.5.5-.5ZM8 14c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 0 1-.5-.5c0-.282.218-.5.5-.5Zm4.5 0c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 0 1-.5-.5c0-.282.218-.5.5-.5Z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(5 1031.362)",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    className: "colorfff svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPom);
export default __webpack_public_path__ + "static/media/pom.28ce6afeaae978bde5010bd48281a2fc.svg";
export { ForwardRef as ReactComponent };